import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import Maps from './Maps';

import FixedBody from '../../ui/Common/FixedBody';
import { hideMapsModal } from '../../app/Maps/actions';

class MapsModal extends React.Component {
  constructor (props) {
    super(props);

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal () {
    this.props.hideMapsModal();
  }

  render () {
    const data = this.props.data;

    return (
      <div className='modal-map'>
        <Modal
          isOpen={data.get('open')}
          onRequestClose={this.handleCloseModal}
          portalClassName='maps-modal'
          className='maps-modal__content'
          overlayClassName='maps-modal__overlay'
        >
          <FixedBody />
          <div className='maps-modal-title'>
            <div className='header'>{data.get('title')}</div>
            <button type='button' className='close' onClick={this.handleCloseModal}>×</button>
          </div>

          <div className='maps-modal-container'>
            <Maps
              similarFilter={data.get('similarFilter')}
              realtyId={data.get('realtyId')}
              realtyType={data.get('realtyType')}
              dealType={data.get('dealType')}
              isSuburb={data.get('isSuburb')}
              lat={data.get('lat')}
              lon={data.get('lon')}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

MapsModal.propTypes = {
  data: PropTypes.object.isRequired,
  hideMapsModal: PropTypes.func.isRequired
};

function mapStateToProps (state) {
  return {
    data: state.getIn(['maps', 'modal'])
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    hideMapsModal
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapsModal);



// WEBPACK FOOTER //
// ./src/ui/Maps/MapsModal.jsx